import type { MapPin } from "../types";
import { usePlacePhotos, useResolvedPinPhoto } from "../hooks/usePlacePhotos";
import { pinMayHavePhoto } from "../lib/googlePlaces";

const CAP = 4;

export function FeedPhotoStrip({
  pin,
  onOpenDetail,
}: {
  pin: MapPin;
  onOpenDetail?: () => void;
}) {
  const { getPhoto } = usePlacePhotos();
  const resolved = useResolvedPinPhoto(pin);
  if (!pinMayHavePhoto(pin) && !pin.imageUrl) return null;

  const places = getPhoto(pin.id);
  const fromPlaces = (places?.mediaUrls ?? []).filter(Boolean).slice(0, CAP);
  const urls: string[] =
    fromPlaces.length > 0
      ? fromPlaces
      : resolved.url
        ? [resolved.url]
        : pin.imageUrl
          ? [pin.imageUrl]
          : [];
  if (urls.length === 0) return null;

  return (
    <div
      className="feed-photo-strip"
      role="list"
      aria-label="Place photos"
      onClick={(e) => {
        e.stopPropagation();
        onOpenDetail?.();
      }}
    >
      {urls.map((src: string, i: number) => (
        <img
          key={`${pin.id}-${i}`}
          role="listitem"
          className="feed-photo"
          src={src}
          alt=""
          loading="lazy"
          draggable={false}
        />
      ))}
    </div>
  );
}
